import { render, staticRenderFns } from "./AdministrationEvent.vue?vue&type=template&id=4c909b42&scoped=true"
import script from "./AdministrationEvent.vue?vue&type=script&lang=js"
export * from "./AdministrationEvent.vue?vue&type=script&lang=js"
import style0 from "./AdministrationEvent.vue?vue&type=style&index=0&id=4c909b42&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c909b42",
  null
  
)

export default component.exports